import { render, staticRenderFns } from "./ChoosePlanPage.vue?vue&type=template&id=7460995b&scoped=true&"
import script from "./ChoosePlanPage.vue?vue&type=script&lang=js&"
export * from "./ChoosePlanPage.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePlanPage.vue?vue&type=style&index=0&id=7460995b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460995b",
  null
  
)

export default component.exports